import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Member } from '../../shared/interface/member.interface';
import { MailingAddressHeight } from '../enums/mailing-address-height.enum';
import { CheckoutConfig } from '../interface/checkout-config.interface';

@Injectable()
export class CheckoutConfigService {
    constructor(
        private _http: Http
    ) { }

    /**
        * @description this method will get the config settings for combo packs page
        * @date 2019-09-16
        * @memberof CartSummaryDetailConfigSettings
        */
    public getSettings(countryCode: string, userInfo: Member): CheckoutConfig {
        let checkoutConfig: CheckoutConfig;
        switch (countryCode.toUpperCase()) {
            case 'USA':
                checkoutConfig = this.loadUSASettings(userInfo);
                break;
            case 'CAN':
                checkoutConfig = this.loadCANSettings(userInfo);
                break;
            case 'GBR':
                checkoutConfig = this.loadGBRSettings(userInfo);
                break;
            case 'ARE':
                checkoutConfig = this.loadARESettings(userInfo);
                break;
            case 'SAU':
                checkoutConfig = this.loadSAUSettings(userInfo);
                break;
            case 'QAT':
                checkoutConfig = this.loadQATSettings(userInfo);
                break;
            case 'IRL':
                checkoutConfig = this.loadIRLSettings(userInfo);
                break;
            case 'ILN':
                checkoutConfig = this.loadILNSettings(userInfo);
                break;
            case 'KWT':
                checkoutConfig = this.loadKWTSettings(userInfo);
                break;
            case 'SWE':
                checkoutConfig = this.loadSWESettings(userInfo);
                break;
            case 'DNK':
                checkoutConfig = this.loadDNKSettings(userInfo);
                break;
            case 'GRL':
                checkoutConfig = this.loadGRLSettings(userInfo);
                break;
            case 'FRO':
                checkoutConfig = this.loadFROSettings(userInfo);
                break;
            case 'FIN':
                checkoutConfig = this.loadFINSettings(userInfo);
                break;
            case 'ALA':
                checkoutConfig = this.loadALASettings(userInfo);
                break;
            case 'NOR':
                checkoutConfig = this.loadNORSettings(userInfo);
                break;
            case 'BHR':
                checkoutConfig = this.loadBHRSettings(userInfo);
                break;
            case 'BEL':
                checkoutConfig = this.loadBELSettings(userInfo);
                break;
            case 'LUX':
                checkoutConfig = this.loadLUXSettings(userInfo);
                break;
            case 'NLD':
                checkoutConfig = this.loadNLDSettings(userInfo);
                break;
            case 'OMN':
                checkoutConfig = this.loadOMNSettings(userInfo);
                break;
            case 'AUS':
                checkoutConfig = this.loadAUSSettings(userInfo);
                break;
            case 'NZL':
                checkoutConfig = this.loadNZLSettings(userInfo);
                break;
            case 'POL':
                checkoutConfig = this.loadPOLSettings(userInfo);
                break;
            case 'MKD':
                checkoutConfig = this.loadMKDSettings(userInfo);
                break;
             case 'BGR':
                checkoutConfig = this.loadBGRSettings(userInfo);
                break;
            case 'DEU':
                checkoutConfig = this.loadDEUSettings(userInfo);
                break;
            case 'AUT':
                checkoutConfig = this.loadAUTSettings(userInfo);
                break;
            case 'ZAF':
                checkoutConfig = this.loadZAFSettings(userInfo);
                break;
            case 'NGA':
                checkoutConfig = this.loadNGASettings(userInfo);
                break;
            case 'CHE':
                checkoutConfig = this.loadCHESettings(userInfo);
                break;
            case 'SEN':
                checkoutConfig = this.loadSENSettings(userInfo);
                break;
            case 'ISL':
                checkoutConfig = this.loadISLSettings(userInfo);
                break;
            case 'TZA':
                checkoutConfig = this.loadTZASettings(userInfo);
                break;
            case 'CIV':
                checkoutConfig = this.loadCIVSettings(userInfo);
                break;
            case 'COD':
                checkoutConfig = this.loadCODSettings(userInfo);
                break;
            case 'GHA':
                checkoutConfig = this.loadGHASettings(userInfo);
                break;
            case 'COG':
                checkoutConfig = this.loadCOGSettings(userInfo);
                break;
            default:
                checkoutConfig = this.loadUSASettings(userInfo);
                break;
        }
        return checkoutConfig;
    }

    /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
    private loadUSASettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'USA',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice:false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: true,
            hideSearchAddressLink : false,
            excludeShippingTaxCalculation: true,
            enableMinAndMaxLimitRules: true,
            removeMobileField:false,
            removePhoneField:false
        };
        return checkoutConfig;
    }

    /**
     * @description this method will return CAN settings
     * @date 2019-09-19
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadCANSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'CAN',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice:false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            displaySystemOrderNumber: true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: true,
            hideSearchAddressLink : false,
            excludeShippingTaxCalculation: true,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
    private loadGBRSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'GBR',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: true,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice: false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            vatInPersonalInfo : true,
            enableMinAndMaxLimitRules: true,
            isParticipatingCountryShippingEnabled: true,
            verifyMailingWithButton: true
        };
        return checkoutConfig;
    }

    /**
   * @description this method will return ARE settings
   * @date 2020-05-12
   * @private
   * @returns {OrderSummaryConfig}
   * @memberof OrderSummaryConfigService
   */
    private loadARESettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'ARE',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
    * @description this method will return SAU settings
    * @date 2020-06-23
    * @private
    * @returns {OrderSummaryConfig}
    * @memberof OrderSummaryConfigService
    */
    private loadSAUSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'SAU',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
     * @description returns QAT checkout settings
     * @author njagadeesan
     * @date 2020-11-24
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadQATSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'QAT',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
    * @description this method will return GBR settings
    * @date 2019-09-19
    * @private
    * @returns {OrderSummaryConfig}
    * @memberof OrderSummaryConfigService
    */
    private loadIRLSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'IRL',
            displayShippingFreeLabel: true,
            showStateCode: true,
            displaySearchAddressSection: true,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice: false,
            findStateByStateName: true,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            vatInPersonalInfo: true,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }
    /**
   * @description this method will return GBR settings
   * @date 2019-09-19
   * @private
   * @returns {OrderSummaryConfig}
   * @memberof OrderSummaryConfigService
   */
    private loadILNSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'ILN',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: true,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice: false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            vatInPersonalInfo: true,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }


    /**
     * @description this method will return KWT settings
     * @author Akhil
     * @date 2020-12-16
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadKWTSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'KWT',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }
    private loadSWESettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'SWE',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }
    private loadDNKSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'DNK',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    private loadGRLSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'GRL',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    private loadFROSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'FRO',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    private loadFINSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'FIN',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    private loadALASettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'ALA',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    private loadNORSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'NOR',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }


    /**
    * @description this method will return BHR settings
    * @date 2021-02-26
    * @private
    * @returns {OrderSummaryConfig}
    * @memberof OrderSummaryConfigService
    */
    private loadBHRSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'BHR',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }


    /**
    * @description this method will return BEL settings
    * @date 2021-02-26
    * @private
    * @returns {OrderSummaryConfig}
    * @memberof OrderSummaryConfigService
    */
    private loadBELSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'BEL',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            enablePosOrderForRetail: true,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
   * @description this method will return LUX settings
   * @date 2021-02-26
   * @private
   * @returns {OrderSummaryConfig}
   * @memberof OrderSummaryConfigService
   */
    private loadLUXSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'LUX',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            enablePosOrderForRetail: true,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
     * @description this method will return NLD settings
     * @date 2021-02-26
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
    private loadNLDSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'NLD',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            enablePosOrderForRetail: true,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
* @description this method will return OMN settings
* @date 2021-03-08
* @private
* @returns {OrderSummaryConfig}
* @memberof OrderSummaryConfigService
*/
    private loadOMNSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'OMN',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
     * @description this method will return AUS settings
     * @author Akhil
     * @date 2021-03-15
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadAUSSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'AUS',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: true,
            isParticipatingCountryShippingEnabled: true,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }


    private loadNZLSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'NZL',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: true,
            mailingAddressHeight: MailingAddressHeight.ROW_4,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    /**
     * @description this method will return POL Settings
     * @author Akhil
     * @date 2021-05-18
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadPOLSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'POL',
            displayShippingFreeLabel: false,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true,
            removeMobileField:true,
            removePhoneField:false
        };
        return checkoutConfig;
    }
    private loadDEUSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'DEU',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: false,
            enableMonthlyCCLimitRules: true,
            disableAddNewCards: true,
            storeTaxInclusivePrice: true
        };
        return checkoutConfig;
    }
    private loadAUTSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'AUT',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity:true,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: false,
            enableMonthlyCCLimitRules: true,
            disableAddNewCards: true,
            storeTaxInclusivePrice: true
        };
        return checkoutConfig;
    }
     /**
     * @description this method will return BGR Settings
     * @date 2022-06-03
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadBGRSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'BGR',
            displayShippingFreeLabel: false,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: false,
            enableMonthlyCCLimitRules: true, 
            enablePosOrderValidation:true,
            disableAddNewCards: false
        };
        return checkoutConfig;
    }
    /**
     * @description this method will return MKD Settings
     * @date 2022-06-03
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadMKDSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'MKD',
            displayShippingFreeLabel: false,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false, 
            enableMinAndMaxLimitRules: false,
            enableMonthlyCCLimitRules: true,  
            enablePosOrderValidation:true      
        };
        return checkoutConfig;
    }
    
    /**
     * @description this method will return ZAF Settings
     * @date 2022-06-03
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadZAFSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
            countryCode: 'ZAF',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,            
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: true,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true 

        }
        return checkoutConfig;
    }
    /**
     * @description this method will return NGA Settings
     * @date 2022-06-03
     * @private
     * @returns {CheckoutConfig}
     * @memberof CheckoutConfigService
     */
    private loadNGASettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
        countryCode: 'NGA',
        displayShippingFreeLabel: false,
        showStateCode: true,
        displaySearchAddressSection:false,
        skipAddressVerification: true,
        displayDeliveryDateSection: true,
        loadParticipatingCountries: true,
        displayIDontHaveSponsorGuestSection: false,
        calculateTaxExclusivePrice: true,
        storeTaxExclusivePrice: true,
        findStateByStateName: false,
        catalogPriceAsTaxablePrice: false,
        applicablePriceAspaidPrice: false,            
        freeShippingFPCOrder: false,
        changeSchemaFormOnCountryChange: true,
        mailingAddressHeight: MailingAddressHeight.ROW_2,
        applicablePriceAsTaxablePrice: false,
        hideSearchAddressLink : false,
        enableMinAndMaxLimitRules: true 

        }
        return checkoutConfig;
    }
    private loadCHESettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'CHE',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            displayBusinessEntity: true,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink: false,
            enableMinAndMaxLimitRules: false,
            enableMonthlyCCLimitRules: true,
            disableAddNewCards: true,
            storeTaxInclusivePrice: true,
            enablePosOrderValidation: false
        };
        return checkoutConfig;
    }

    private loadSENSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
            countryCode: 'SEN',
            displayShippingFreeLabel: true,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: false,
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink: false,
            enableMinAndMaxLimitRules: false,
            displayCityBasedOnState:true

        }
        return checkoutConfig;
    }
    private loadISLSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig = {
            countryCode: 'ISL',
            displayShippingFreeLabel: true,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: false,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: false,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: false,
            storeTaxExclusivePrice: false,
            findStateByStateName: true,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: true,
            freeShippingFPCOrder: true,
            changeSchemaFormOnCountryChange: false,
            mailingAddressHeight: MailingAddressHeight.ROW_3,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink: false,
            vatInPersonalInfo: true,
            enableMinAndMaxLimitRules: true
        };
        return checkoutConfig;
    }

    private loadTZASettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
            countryCode: 'TZA',
            displayShippingFreeLabel: false,
            showStateCode: false,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: false,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: true,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: false,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: true,
            applicablePriceAspaidPrice: false,            
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: true,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true,
            displayCityBasedOnState:true

        }
        return checkoutConfig;
    }

    private loadCIVSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
            countryCode: 'CIV',
            displayShippingFreeLabel: false,
            showStateCode: true,
            displaySearchAddressSection: false,
            skipAddressVerification: true,
            displayDeliveryDateSection: true,
            loadParticipatingCountries: true,
            displayIDontHaveSponsorGuestSection: false,
            calculateTaxExclusivePrice: true,
            storeTaxExclusivePrice: true,
            findStateByStateName: false,
            catalogPriceAsTaxablePrice: false,
            applicablePriceAspaidPrice: false,            
            freeShippingFPCOrder: false,
            changeSchemaFormOnCountryChange: true,
            mailingAddressHeight: MailingAddressHeight.ROW_2,
            applicablePriceAsTaxablePrice: false,
            hideSearchAddressLink : false,
            enableMinAndMaxLimitRules: true 

        }
        return checkoutConfig;
    }

    private loadCODSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
        countryCode: 'COD',
        displayShippingFreeLabel: false,
        showStateCode: true,
        displaySearchAddressSection:false,
        skipAddressVerification: true,
        displayDeliveryDateSection: true,
        loadParticipatingCountries: true,
        displayIDontHaveSponsorGuestSection: false,
        calculateTaxExclusivePrice: true,
        storeTaxExclusivePrice: true,
        findStateByStateName: false,
        catalogPriceAsTaxablePrice: false,
        applicablePriceAspaidPrice: false,            
        freeShippingFPCOrder: false,
        changeSchemaFormOnCountryChange: true,
        mailingAddressHeight: MailingAddressHeight.ROW_2,
        applicablePriceAsTaxablePrice: false,
        hideSearchAddressLink : false,
        enableMinAndMaxLimitRules: true 

        }
        return checkoutConfig;
    }

    private loadGHASettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
        countryCode: 'GHA',
        displayShippingFreeLabel: false,
        showStateCode: true,
        displaySearchAddressSection:false,
        skipAddressVerification: true,
        displayDeliveryDateSection: true,
        loadParticipatingCountries: true,
        displayIDontHaveSponsorGuestSection: false,
        calculateTaxExclusivePrice: true,
        storeTaxExclusivePrice: true,
        findStateByStateName: false,
        catalogPriceAsTaxablePrice: false,
        applicablePriceAspaidPrice: false,            
        freeShippingFPCOrder: false,
        changeSchemaFormOnCountryChange: true,
        mailingAddressHeight: MailingAddressHeight.ROW_2,
        applicablePriceAsTaxablePrice: false,
        hideSearchAddressLink : false,
        enableMinAndMaxLimitRules: true 

        }
        return checkoutConfig;
    }

    private loadCOGSettings(userInfo: Member): CheckoutConfig {
        const checkoutConfig: CheckoutConfig ={
        countryCode: 'COG',
        displayShippingFreeLabel: false,
        showStateCode: true,
        displaySearchAddressSection:false,
        skipAddressVerification: true,
        displayDeliveryDateSection: true,
        loadParticipatingCountries: true,
        displayIDontHaveSponsorGuestSection: false,
        calculateTaxExclusivePrice: true,
        storeTaxExclusivePrice: true,
        findStateByStateName: false,
        catalogPriceAsTaxablePrice: false,
        applicablePriceAspaidPrice: false,            
        freeShippingFPCOrder: false,
        changeSchemaFormOnCountryChange: true,
        mailingAddressHeight: MailingAddressHeight.ROW_2,
        applicablePriceAsTaxablePrice: false,
        hideSearchAddressLink : false,
        enableMinAndMaxLimitRules: true 

        }
        return checkoutConfig;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/checkout-config.service.ts